import { useEffect, useState } from "react";

import { NEXT_PUBLIC_IMAGE_URL } from "@/constants/env";
import { Box } from "@chakra-ui/react";
import { Image } from "@picovico/ui";
import { HashLoader } from "react-spinners";

function FullPageLoader() {
  const [imagePath, setImagePath] = useState<string | null>(null);

  useEffect(() => {
    const baseUrl = NEXT_PUBLIC_IMAGE_URL ?? process.env.NEXT_PUBLIC_IMAGE_URL;
    const hostname = window.location.hostname;

    if (baseUrl) {
      setImagePath(`${baseUrl}/${hostname}.png`);
    } else {
      setImagePath(null);
    }
  }, []);

  if (!imagePath) {
    return (
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        }}
      >
        <HashLoader color="#36d7b7" />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "white",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      <Image
        src={imagePath}
        mt={8}
        boxSize="200px"
        sx={{
          animation: `zoomIn 2s infinite`,
        }}
        alt="loading..."
      />
    </Box>
  );
}

export default FullPageLoader;
